import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import router from "../router";

Vue.use(Vuex);
axios.defaults.baseURL = `${process.env.VUE_APP_BASE_URL}/api`;

export const store = new Vuex.Store({
  state: {
    token: localStorage.getItem("access_token") || null,
    access_lvl: localStorage.getItem("access_lvl") || 0,
    user_id: localStorage.getItem("user_id") || 0,
    filter: "all",
    todos: []
  },
  getters: {
    loggedIn(state) {
      return state.token !== null;
    },
    getAccessLevel(state) {
      return state.access_lvl;
    },
    getUser_id(state) {
      return state.user_id;
    }
  },
  mutations: {
    retrieveToken(state, token) {
      state.token = token;
    },
    retrieveAccess(state, access_lvl) {
      state.access_lvl = access_lvl;
    },
    retrieveUser_id(state, user_id) {
      state.user_id = user_id;
    },
    destroyToken(state) {
      state.token = null;
      state.access_lvl = 0;
    }
  },
  actions: {
    // axios.defaults.headers.post['Content-Type'] = 'application/json';
    destroyToken(context) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;

      if (context.getters.loggedIn) {
        return new Promise((resolve, reject) => {
          axios
            .post("/logout")
            .then(response => {
              localStorage.removeItem("access_token");
              localStorage.removeItem("access_lvl");
              localStorage.removeItem("user_id");
              context.commit("destroyToken");
              resolve(response);
              // context.commit('addTodo', response.data)
            })
            .catch(error => {
              localStorage.removeItem("access_token");
              localStorage.removeItem("access_lvl");
              localStorage.removeItem("user_id");
              context.commit("destroyToken");
              reject(error);
            });
        });
      }
    },
    retrieveToken(context, credentials) {
      return new Promise((resolve, reject) => {
        axios
          .post(
            `/login?email=${credentials.username}&password=${credentials.password}&login_status=${credentials.login_status}`
          )
          .then(response => {
            const token = response.data.data.token;
            const accessLvl = response.data.data.userdetails.access_lvl;
            const user_id = response.data.data.userdetails.user_id;

            localStorage.setItem("access_token", token);
            localStorage.setItem("access_lvl", accessLvl);
            localStorage.setItem("user_id", user_id);

            context.commit("retrieveToken", token);
            context.commit("retrieveAccess", accessLvl);
            context.commit("retrieveUser_id", user_id);
            resolve(response);
            // context.commit('addTodo', response.data)
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // Get Reftable
    getReftable(context, param) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .get(`reftable?ref_code[]=${param}`)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // Get Stockout
    getStockout(context, param) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      let url;
      if (param.user_id === undefined) {
        url = `/user/stockout`;
      } else {
        url = `/user/stockout?user_id=${param.user_id}&page=${param.page}`;
      }
      return new Promise((resolve, reject) => {
        axios
          .get(url)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // Get Stockout
    getStockoutList(context, param) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .get(`/user/stockout?page=${param}`)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // Show Stockout
    showStockout(context, param) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .get(`/user/stockout/one?stock_id=${param.stock_id}`)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // Show Monthly Forecast
    showMF(context, param) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .get(`user/forcast/one?fc_id=${param.fc_id}`)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // Get Purchase Order
    getPO(context, param) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;

      let url;
      if (param.user_id === undefined) {
        url = `/user/stock?category=${param.category}`;
      } else {
        url = `/user/stock?category=${param.category}&user_id=${param.user_id}`;
      }
      return new Promise((resolve, reject) => {
        axios
          .get(url)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // Get PO
    getPOList(context, param) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .get(`user/purchase?page=${param}`)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // post PO
    postPO(context, param) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .post(`user/purchase`, param)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // Show PO
    showPO(context, param) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .get(`user/purchase/one?purchase_id=${param}`)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // Delete PO
    deletePO(context, param) {
      axios.defaults.headers.post["Content-Type"] = "application/json";
      axios.defaults.headers.post["Accept"] =
        "application/x-www-form-urlencoded";
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .post(`user/purchase/delete`, {
            purchase_id: param
          })
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // Search stockout
    searchPO(context, param) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        if (param.date) {
          axios
            .get(`user/purchase/search?date=${param.date}&page=${param.page}`)
            .then(response => {
              resolve(response);
            })
            .catch(error => {
              reject(error);
            });
        } else if (param.name) {
          axios
            .get(`user/purchase/search?name=${param.name}&page=${param.page}`)
            .then(response => {
              resolve(response);
            })
            .catch(error => {
              reject(error);
            });
        }
      });
    },

    // Get Delivery Order
    getDO(context, param) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;

      let url;
      if (param.user_id === undefined) {
        url = `/user/stock?category=${param.category}`;
      } else {
        url = `/user/stock?category=${param.category}&user_id=${param.user_id}`;
      }

      return new Promise((resolve, reject) => {
        axios
          .get(url)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // Get DO
    getDOList(context, param) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .get(`user/delivery?page=${param}`)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // post DO
    postDO(context, param) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .post(`user/delivery`, param)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // Show DO
    showDO(context, param) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .get(`user/delivery/one?delivery_id=${param}`)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // Delete DO
    deleteDO(context, param) {
      axios.defaults.headers.post["Content-Type"] = "application/json";
      axios.defaults.headers.post["Accept"] =
        "application/x-www-form-urlencoded";
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .post(`user/delivery/delete`, {
            delivery_id: param
          })
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // Search DO
    searchDO(context, param) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        if (param.date) {
          axios
            .get(`user/delivery/search?date=${param.date}&page=${param.page}`)
            .then(response => {
              resolve(response);
            })
            .catch(error => {
              reject(error);
            });
        } else if (param.name) {
          axios
            .get(`user/delivery/search?name=${param.name}&page=${param.page}`)
            .then(response => {
              resolve(response);
            })
            .catch(error => {
              reject(error);
            });
        }
      });
    },

    // Get Monthly Forecast
    getMF(context, param) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .get("user/forcast/all?" + param)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    updateStatusMF(context, param) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;

      return new Promise((resolve, reject) => {
        axios
          .post(`user/stock/status`, param)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // Add or update single product for MF
    createWeekMF(context, param) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;

      return new Promise((resolve, reject) => {
        axios
          .post(`user/forcast/week`, param)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // Create Forecast
    createForecast(context, param) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;

      return new Promise((resolve, reject) => {
        axios
          .post(`user/forcast`, {
            year: param.year,
            month: param.month,
            type: param.type
          })
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // Delete Product for MF
    deleteProMF(context, param) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;

      return new Promise((resolve, reject) => {
        axios
          .post(`user/stock/dprostock`, {
            pro_stock_id: param
          })
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // Delete MF
    deleteMF(context, param) {
      axios.defaults.headers.post["Content-Type"] = "application/json";
      axios.defaults.headers.post["Accept"] =
        "application/x-www-form-urlencoded";
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .post(`user/forcast/delete`, {
            fc_id: param
          })
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // Search MF
    searchMF(context, param) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .get(`user/forcast/search?name=${param.name}&page=${param.page}`)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // Get Stockout Changes
    getSC(context, category) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .get(`/user/stock?category=${category}`)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // Show Stockout Changes
    showSC(context, param) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .get(`/user/stock/${param.amend_changes_id}/${param.category}`)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // Get Outlet
    getOutlet(context) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .get(`admin/outlet`)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // Post Outlet
    createOutlet(context, param) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .post(`admin/outlet`, {
            name: param.name,
            suboutlet: param.suboutlet,
            typeoutlet: param.typeoutlet,
            outlet_id: param.outlet_id
          })
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // Delete Outlet
    deleteOutlet(context, param) {
      axios.defaults.headers.post["Content-Type"] = "application/json";
      axios.defaults.headers.post["Accept"] =
        "application/x-www-form-urlencoded";
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .post(`admin/outlet/delete`, {
            outlet_id: param.outlet_id
          })
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // Post Product
    createProduct(context, param) {
      return new Promise((resolve, reject) => {
        axios({
          method: "post",
          url: "admin/product",
          data: param,
          headers: {
            Authorization: "Bearer " + context.state.token,
            "Content-Type": "multipart/form-data"
          }
        })
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // Get Product
    getProduct(context) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .get(`admin/product`)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // Get Product Pagination
    getProductPaginate(context, param) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .get(`admin/product/paginate?page=${param}`)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // Get Product Pagination
    searchProduct(context, param) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .get(`admin/product/search?name=${param.name}&page=${param.page}`)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // Show Product
    showProduct(context, param) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .get(`/admin/product/one?product_id=${param.product_id}`)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // Delete Product
    deleteProduct(context, param) {
      axios.defaults.headers.post["Content-Type"] = "application/json";
      axios.defaults.headers.post["Accept"] =
        "application/x-www-form-urlencoded";
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .post(`admin/product/delete`, {
            product_id: param.product_id
          })
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // Post User Management
    createUser(context, param) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .post(`auth`, param)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // Get User Management
    getUser(context, param) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .get(`auth/all?page=${param}`)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // Show User Management
    showUser(context, param) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .get(`auth?user_id=${param.user_id}`)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            localStorage.removeItem("access_token");
            localStorage.removeItem("access_lvl");
            localStorage.removeItem("user_id");
            context.commit("destroyToken");
            reject(error);
            router.push({ name: "login" });
          });
      });
    },

    //Delete User Management
    deleteUser(context, param) {
      axios.defaults.headers.post["Content-Type"] = "application/json";
      axios.defaults.headers.post["Accept"] =
        "application/x-www-form-urlencoded";
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .post(`auth/delete`, {
            user_id: param.user_id
          })
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // Search User M
    searchUser(context, param) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        if (param.name) {
          axios
            .get(`auth/search?name=${param.name}&page=${param.page}`)
            .then(response => {
              resolve(response);
            })
            .catch(error => {
              reject(error);
            });
        } else if (param.state) {
          axios
            .get(`auth/search?state=${param.state}&page=${param.page}`)
            .then(response => {
              resolve(response);
            })
            .catch(error => {
              reject(error);
            });
        } else if (param.email) {
          axios
            .get(`auth/search?email=${param.email}&page=${param.page}`)
            .then(response => {
              resolve(response);
            })
            .catch(error => {
              reject(error);
            });
        } else if (param.access_lvl) {
          axios
            .get(
              `auth/search?access_lvl=${param.access_lvl}&page=${param.page}`
            )
            .then(response => {
              resolve(response);
            })
            .catch(error => {
              reject(error);
            });
        }
      });
    },

    // Download User
    downloadUser(context, param) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        if (param.state && param.user_id) {
          axios
            .get(`excel/userlist?state=${param.state}&user_id=${param.user_id}`)
            .then(response => {
              resolve(response);
            })
            .catch(error => {
              reject(error);
            });
        } else if (param.state && !param.user_id) {
          axios
            .get(`excel/userlist?state=${param.state}`)
            .then(response => {
              resolve(response);
            })
            .catch(error => {
              reject(error);
            });
        } else {
          axios
            .get(`excel/userlist`)
            .then(response => {
              resolve(response);
            })
            .catch(error => {
              reject(error);
            });
        }
      });
    },

    // Get Upline
    getUpline(context) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .get(`upline`)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // Get SubDealer
    getSubDealer(context, param) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .get(`downline?page=${param}`)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // Search SubDealer
    searchSubDealer(context, param) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        if (param.name) {
          axios
            .get(`downline?name=${param.name}&page=${param.page}`)
            .then(response => {
              resolve(response);
            })
            .catch(error => {
              reject(error);
            });
        } else if (param.email) {
          axios
            .get(`downline?email=${param.email}&page=${param.page}`)
            .then(response => {
              resolve(response);
            })
            .catch(error => {
              reject(error);
            });
        }
      });
    },

    // Get DownlineStockout
    getDownlineStockout(context, param) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        if (param.user_id) {
          axios
            .get(
              `user/downlinestock?user_id=${param.user_id}&page=${param.page}`
            )
            .then(response => {
              resolve(response);
            })
            .catch(error => {
              reject(error);
            });
        } else {
          axios
            .get(`user/downlinestock?page=${param.page}`)
            .then(response => {
              resolve(response);
            })
            .catch(error => {
              reject(error);
            });
        }
      });
    },
    // Search DownlineStockout
    searchDownlineStockout(context, param) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        if (param.name) {
          axios
            .get(
              `user/downlinestock?user_id=${param.user_id}&name=${param.name}&page=${param.page}`
            )
            .then(response => {
              resolve(response);
            })
            .catch(error => {
              reject(error);
            });
        } else if (param.outlet_name) {
          axios
            .get(
              `user/downlinestock?user_id=${param.user_id}&main_outlet_name=${param.outlet_name}&page=${param.page}`
            )
            .then(response => {
              resolve(response);
            })
            .catch(error => {
              reject(error);
            });
        } else if (param.date) {
          axios
            .get(
              `user/downlinestock?user_id=${param.user_id}&date=${param.date}&page=${param.page}`
            )
            .then(response => {
              resolve(response);
            })
            .catch(error => {
              reject(error);
            });
        }
      });
    },

    // Get Notification User
    getNotiUser(context) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .get(`notification`)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // Post Change Password USER
    changePassword(context, param) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .post(`auth`, param)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    //create multi stock
    createMultiStock(context, param) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .post(`user/stock`, param)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // Download Invoice
    getInvoice(context, param) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .get(`invoice?any_id=${param.stock_id}&category=${param.category}`)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // Download PO Report
    getPOReport(context, param) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .get(`excel/purchase?any_id=${param.any_id}`)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // Download Invoice
    getDOReport(context, param) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .get(`excel/delivery?any_id=${param.any_id}`)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // Send forget pw email
    resetPW_email(context, param) {
      return new Promise((resolve, reject) => {
        axios
          .get(`auth/forget?email=${param.email}`)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // Submit year
    submitPW(context, param) {
      return new Promise((resolve, reject) => {
        axios
          .post(`auth/reset`, {
            email: param.email,
            password: param.password,
            token: param.token
          })
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // getYear
    getYear(context) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .get(`user/forcast`)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // get graph
    getGraph(context) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .get(`user/graph`)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // get Number
    getNumber(context) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .get(`user/dashbaord`)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // get upline
    getUplineStock(context, param) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .get(`upline?state=${param}`)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    getOutletHistory(context) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .get(`upline/outlet/user`)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    getOutletSelf(context) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .get(`admin/outlet/user`)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // Upload Invoice
    uploadInvoice(context, param) {
      return new Promise((resolve, reject) => {
        axios
          .post(`invoice`, param)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    getInvoiceList(context, param) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .get(`invoice/stock?any_id=${param}`)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // Delete invoice
    deleteInvoice(context, param) {
      axios.defaults.headers.post["Content-Type"] = "application/json";
      axios.defaults.headers.post["Accept"] =
        "application/x-www-form-urlencoded";
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .post(`invoice/delete`, {
            generate_doc_id: param
          })
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    getStockoutAdmin(context, param) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .get(
            `user/downlinestock/admin?user_id=${param.user_id}&year=${param.year}&month=${param.month}&page=${param.page}`
          )
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    getYearUpline(context, param) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        if (param.state) {
          axios
            .get(
              `user/stock/listyear?user_id=${param.upline}&state=${param.state}`
            )
            .then(response => {
              resolve(response);
            })
            .catch(error => {
              reject(error);
            });
        } else {
          axios
            .get(`user/stock/listyear?user_id=${param.upline}`)
            .then(response => {
              resolve(response);
            })
            .catch(error => {
              reject(error);
            });
        }
      });
    },

    downloadExcel(context, param) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;

      let url = "";
      if (param.outlet_category === null) {
        url = `excel/stockout?user_id=${param.user_id}&month=${param.month}&outlet_id=${param.outlet_id}`;
      } else {
        url = `excel/stockout?user_id=${param.user_id}&month=${param.month}&outlet_id=${param.outlet_id}& outlet_category=${param.outlet_category}`;
      }
      return new Promise((resolve, reject) => {
        axios
          .get(url)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    downloadExcelAdmin(context, param) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        if (param.user_id) {
          axios
            .get(
              `excel/stockout?user_id=${param.user_id}&state=${param.state}&year=${param.year}&month=${param.month}&report_type=${param.report_type}&report_category=${param.report_category}`
            )
            .then(response => {
              resolve(response);
            })
            .catch(error => {
              reject(error);
            });
        } else {
          axios
            .get(
              `excel/stockout?year=${param.year}&month=${param.month}&report_type=${param.report_type}&report_category=${param.report_category}`
            )
            .then(response => {
              resolve(response);
            })
            .catch(error => {
              reject(error);
            });
        }
      });
    },

    getHomeDealer(context) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .get(`upline/homedealer`)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    getUplineAdmin(context, param) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .get(`upline?state=${param}`)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    getDownlineAdmin(context, param) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .get(`downline?user_id=${param.user_id}&page=${param.page}`)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    searchDownlineAdmin(context, param) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        if (param.name) {
          axios
            .get(
              `downline?user_id=${param.user_id}&name=${param.name}&page=${param.page}`
            )
            .then(response => {
              resolve(response);
            })
            .catch(error => {
              reject(error);
            });
        } else if (param.email) {
          axios
            .get(
              `downline?user_id=${param.user_id}&email=${param.email}&page=${param.page}`
            )
            .then(response => {
              resolve(response);
            })
            .catch(error => {
              reject(error);
            });
        }
      });
    },

    getStockoutSubDAdmin(context, param) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .get(`user/downlinestock?user_id=${param.user_id}`)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    getPOSubDAdmin(context, param) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .get(`${param}`)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    getDOSubDAdmin(context, param) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .get(`${param}`)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    getMFSubDAdmin(context, param) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .get(`${param}`)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    getIndividualDownline(context, param) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .get(`downline?user_id=${param}`)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    searchIndividualDownline(context, param) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        if (param.name) {
          axios
            .get(
              `downline?user_id=${param.user_id}&name=${param.name}&page=${param.page}`
            )
            .then(response => {
              resolve(response);
            })
            .catch(error => {
              reject(error);
            });
        } else if (param.email) {
          axios
            .get(
              `downline?user_id=${param.user_id}&email=${param.email}&page=${param.page}`
            )
            .then(response => {
              resolve(response);
            })
            .catch(error => {
              reject(error);
            });
        }
      });
    },

    // Get Outlet Name History
    getOutletName(context) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .get(`user/outlet`)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // Get Outlet Name History
    getOutletNameHistory(context, param) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .get(`user/outlet/paginate?page=${param}`)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // Get Outlet Name History
    searchOutletNameHistory(context, param) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .get(
            `user/outlet/search?outlet_name=${param.outlet_name}&page=${param.page}`
          )
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // Post Outlet Name History
    createOutletNameHistory(context, param) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .post(`user/outlet`, param)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // Delete Outlet Name History
    deleteOutletNameHistory(context, param) {
      axios.defaults.headers.post["Content-Type"] = "application/json";
      axios.defaults.headers.post["Accept"] =
        "application/x-www-form-urlencoded";
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .post(`user/outlet/delete`, {
            outlet_user_id: param.outlet_user_id
          })
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // Post Outlet Sub / Type
    createSubOutlet(context, param) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .post(`admin/suboutlet`, param)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // Delete Outlet Sub / Type
    deleteSubOutlet(context, param) {
      axios.defaults.headers.post["Content-Type"] = "application/json";
      axios.defaults.headers.post["Accept"] =
        "application/x-www-form-urlencoded";
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .post(`admin/suboutlet/delete`, {
            sub_outlet_id: param.sub_outlet_id
          })
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // Search stockout
    searchStockout(context, param) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        if (param.id) {
          if (param.date) {
            axios
              .get(
                `user/stockout/search?user_id=${param.id}&date=${param.date}&page=${param.page}`
              )
              .then(response => {
                resolve(response);
              })
              .catch(error => {
                reject(error);
              });
          } else if (param.outlet_name) {
            axios
              .get(
                `user/stockout/search?user_id=${param.id}&outlet_name=${param.outlet_name}&page=${param.page}`
              )
              .then(response => {
                resolve(response);
              })
              .catch(error => {
                reject(error);
              });
          } else if (param.main_outlet_name) {
            axios
              .get(
                `user/stockout/search?user_id=${param.id}&main_outlet_name=${param.main_outlet_name}&page=${param.page}`
              )
              .then(response => {
                resolve(response);
              })
              .catch(error => {
                reject(error);
              });
          }
        } else {
          if (param.date) {
            axios
              .get(`user/stockout/search?date=${param.date}&page=${param.page}`)
              .then(response => {
                resolve(response);
              })
              .catch(error => {
                reject(error);
              });
          } else if (param.outlet_name) {
            axios
              .get(
                `user/stockout/search?outlet_name=${param.outlet_name}&page=${param.page}`
              )
              .then(response => {
                resolve(response);
              })
              .catch(error => {
                reject(error);
              });
          } else if (param.main_outlet_name) {
            axios
              .get(
                `user/stockout/search?main_outlet_name=${param.main_outlet_name}&page=${param.page}`
              )
              .then(response => {
                resolve(response);
              })
              .catch(error => {
                reject(error);
              });
          }
        }
      });
    },
    // Search stockout Admin
    searchStockoutAdmin(context, param) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        if (param.date) {
          axios
            .get(
              `user/downlinestock/admin?user_id=${param.upline}&year=${param.year}&month=${param.month}&date=${param.date}&page=${param.page}`
            )
            .then(response => {
              resolve(response);
            })
            .catch(error => {
              reject(error);
            });
        } else if (param.outlet_name) {
          axios
            .get(
              `user/downlinestock/admin?user_id=${param.upline}&year=${param.year}&month=${param.month}&main_outlet_name=${param.outlet_name}&page=${param.page}`
            )
            .then(response => {
              resolve(response);
            })
            .catch(error => {
              reject(error);
            });
        } else if (param.name) {
          axios
            .get(
              `user/downlinestock/admin?user_id=${param.upline}&year=${param.year}&month=${param.month}&name=${param.name}&page=${param.page}`
            )
            .then(response => {
              resolve(response);
            })
            .catch(error => {
              reject(error);
            });
        }
      });
    },

    // post stockout
    postStockout(context, param) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .post(`user/stockout`, param)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // Delete Stockout
    deleteStockout(context, param) {
      axios.defaults.headers.post["Content-Type"] = "application/json";
      axios.defaults.headers.post["Accept"] =
        "application/x-www-form-urlencoded";
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .post(`user/stockout/delete`, {
            stock_id: param
          })
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    getAudit(context, param) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      axios.defaults.headers.post["Content-Type"] = "application/json";

      return new Promise((resolve, reject) => {
        axios
          .get(`admin/audit?page=${param}`)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    getSearchAudit(context, param) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      axios.defaults.headers.post["Content-Type"] = "application/json";

      return new Promise((resolve, reject) => {
        axios
          .get(param)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    }
  }
});
